import React from 'react';
import { validated } from 'react-custom-validation'
import PropTypes from 'prop-types';

import { isEmail, isRequired } from 'utils/validations';
import { handleTextChange } from 'utils/handle-changes';

import Button from 'components/Button';
import Form from 'components/Form';
import FormValidationMessage from 'components/FormValidationMessage';
import FormRow from 'components/FormRow';
import H3 from 'components/H3';
import LoadingCircle from 'components/LoadingCircle';
import Textbox from 'components/Textbox';

class LoginForm extends React.Component {
    static propTypes = {
        credentials: PropTypes.object.isRequired,
        error: PropTypes.object.isRequired,
        handleChange: PropTypes.func.isRequired,
        isFetching: PropTypes.bool.isRequired,
        onValid: PropTypes.func.isRequired,
        onInvalid: PropTypes.func.isRequired
    };

    render() {
        let { credentials, error, handleChange, isFetching, onValid, onInvalid, $field, $validation } = this.props;

        return (
            <Form className="auth-form">
                <H3>
                    Login to your account
                </H3>

                <FormRow>
                    <Textbox
                        icon="email"
                        id="txtEmailAddress"
                        label="Email"
                        name="email"
                        required
                        type="email"
                        validation={$validation.email}
                        value={credentials.email || ''}
                        {...$field('email', (event) => handleTextChange(handleChange, event))}
                    />
                </FormRow>

                <FormRow>
                    <Textbox
                        icon="lock"
                        id="txtPassword"
                        label="Password"
                        name="password"
                        required
                        type="password"
                        validation={$validation.password}
                        value={credentials.password || ''}
                        {...$field('password', (event) => handleTextChange(handleChange, event))}
                    />
                </FormRow>

                <FormRow className="error-message">
                    {Object.keys(error).length > 0 ? (
                        <FormValidationMessage>
                            {error.friendlyMessage || error.message}
                        </FormValidationMessage>
                    ) : null}
                </FormRow>

                <FormRow className="button-wrapper">
                    <Button className="a-button--blue"
                            disabled={isFetching === true}
                            onClick={(event) => {
                                event.preventDefault();
                                this.props.$submit(onValid, onInvalid);
                            }}
                            type="submit">
                        Login
                        {isFetching === true ? <LoadingCircle innerColor="#ffffff" outerColor="#ffffff" /> : null}
                    </Button>
                </FormRow>
            </Form>
        )
    }
}

function loginFormValidationConfig(props) {
    const { email, password } = props.credentials;

    return {
        fields: ['email', 'password'],
        validations: {
            email: [
                [isRequired, email],
                [isEmail, email]
            ],
            password: [
                [isRequired, password]
            ]
        }
    }
}

export default LoginForm = validated(loginFormValidationConfig)(LoginForm);



// WEBPACK FOOTER //
// ./src/containers/Auth/LoginPage/LoginForm.js